module.exports = __webpack_public_path__ + "media/close.ec509020.svg";